import React, {
  Suspense,
  lazy,
  useEffect,
  useRef,
  useCallback,
  useState,
  useContext,
} from "react";
import { RightOutlined, SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

import { Popover } from "@mui/material";
import { DatePicker } from "antd";
import { ErrorMessage, Form, Formik } from "formik";
import * as Yup from "yup";
import TextError from "../../TextError";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import axios from "axios";
import {
  clearSearchRateAvailableData,
  getallairports,
  searchRateAnimation,
  searchrates,
  searchratestate,
  resetSearchRatesState ,
} from "../../../store/SearchRates/SearchRatesSlice";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { IncoTerms } from "../../../utils/incoTermsDatas";
import { Modal, Skeleton } from "antd";
import moment from "moment/moment";
import { useSearchParams } from "react-router-dom";
import {
  authtokenloginAirline,
  loginAirline,
} from "../../../store/LoginAirlineAuth/AuthSlice";
import { set } from "react-hook-form";
import {
  vehicletype,
  caldistance,
} from "../../../store/vehicletype/Vehicletypeslice";
import { updatenotificationdata } from "../../../store/Admin/Common/CommonSlice";
import FailureSearchRate from "../../../components/SearchRates/FailureSearchRate";
import { ManageSocketContext } from "../../../ManageSocketContext";

import { getsinglebookingdata } from "../../../store/BookingHistory/BookingHistorySlice";
import { checkStackableandTurnable } from "../../../utils/dropdownValues";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const OriginAirport = lazy(() => import("./OriginAirport/OriginAirport"));
const DestinationAirport = lazy(() =>
  import("./DestinationAirport/DestinationAirport")
);
const GoodDetails = lazy(() => import("./GoodsDetails/GoodDetails"));
const PackagingDetails = lazy(() =>
  import("./PackagingDetails/PackagingDetails")
);
const PaymentTerms = lazy(() => import("./PaymentTerms/PaymentTerms"));

// This module-scoped variable (not localStorage) holds the short-lived
// bearer token this component fetches from the external cdutils.sgate.net
// commodity API. It used to be persisted to localStorage under
// "tokenairline", which meant it survived reloads/new tabs and was readable
// by any script on the page (auth-hardening pass — no auth-bearing token in
// script-readable browser storage). A plain in-memory variable keeps the
// exact same "read it back later in this page session" behavior the code
// relies on without leaving it sitting in persistent storage. This is
// unrelated to the user's own login session (handled entirely via httpOnly
// cookies elsewhere) — it's a token for this one internal service call.
let cdutilsAirlineToken = null;

const NewFlightRate = ({ searchBy, searchFormData, type }) => {
  console.log(searchFormData, "searchFormData");
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const { searchratesAvailableData } = useSelector(searchratestate);
  const { hasnodata, setReceivingResponse, receivingResponse } =
    useContext(ManageSocketContext);
  // console.log(receivingResponse,"receivingResponse")
  //    console.log(hasnodata ,"hasnodata")
  const [formikData, setFormikData] = useState(null);

  const [popForm, setPopForm] = useState();
  const [airports, setAirports] = useState([]);
  const [webopen, setWebOpen] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState(null);
  const [popup, setPopup] = useState("");
  const [origin, setOrigin] = useState("");
  const [originvehicle, setOriginVehicle] = useState([]);
  const [destinationvehicle, setDestinationVehicle] = useState([]);
  const [destination, setDestination] = useState("");
  const [searchquery, setSearchQuery] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState({
    destinationVehicle: "",
    originVehicle: "",
  });
  const [originDistance, setOriginDistance] = useState();
  const [editdata, setEditData] = useState({});
  const [editbookeditem, setEditbookeditem] = useState();
  const [editpayload, setEditPayload] = useState({});
  const [destinationDistance, setDestinationDistance] = useState();
  const [vasoptiondata, setVasOptionData] = useState([]);
  const editQueryData = location?.state;
  const [empty, setEmpty] = useState(false);
  const [comodityMaster, setcomodityMaster] = useState([]);
  const [airlinetoken, setairlinetoken] = useState("");
  const [productDetails, setProductDetails] = useState({
    "commodityCode": "9999",
    "dgShipment": false,
    "natureOfGoods": "General Cargo",
    "productCode": "GCR",
    "commodityId": 98,
    "specialHandlingCodes": [
        "GCR"
    ]
});
  const [commodityid, setCommodityid] = useState("98");
  const [commodityformik,setcommodityformik]=useState();
  const [temperaturecontrol, setTemperatureControl] = useState({
    tempraturerange: searchFormData?.searchquery?.temperatureRange,
    upperbound: searchFormData?.searchquery?.upperBound ,
    lowerbound: searchFormData?.searchquery?.lowerBound ,
  });
  const [selecteddate,setSelectedDate] = useState("")
  const [selectedcomondity,setSelectedComondity] = useState("")
  
  // console.log(temperaturecontrol, editdata ,searchFormData, "temperaturecontrol12");
    //  console.log(productDetails, "productDetails")

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const queryId = searchParams.get("queryId");
// console.log(editbookeditem,"editbookeditem")
  // console.log(searchquery, "searchquery");
  // console.log("queryId", queryId);
  // console.log(
  //   "editQueryData",
  //   editdata,
  //   editQueryData,
  //   editbookeditem,
  //   editpayload
  // );
  const allAirportsState = useSelector(searchratestate);

  // useEffect(() => {
  //   dispatch(resetSearchRatesState());
  // }, [location.pathname]);
  // console.log(selectedVehicle, "selectedVehiclefdg");
  // console.log("countrynamehiiooo", type, searchBy, searchFormData);
  const handleClick = (event, formik, popform) => {
    if (type === "kam_admin") return;
    // console.log(formik, "formikhandleclcik");
    setAnchorEl(event.currentTarget);
    //  if(popform==="GoodDetails"){
    //   setcommodityformik(formik)
    //  }
    setFormikData(formik);
    setPopForm(popform);
    // console.log(searchFormData, "yhbrt");
  };
  // const handlechangeforcommodity =(formik)=>{
  //    console.log("handlechangeforcommodity",formik)
  //    setcommodityformik(formik)
  //   //  const [commodityformik,setcommodityformik]=useState();
  // }

//   const handlechangeforcommodity =(e,formik) => {
//   // console.log("handlechangeforcommodity");
//   formik.setFieldValue("commodityType", e.target.value);
//   setcommodityformik(formik);
// }
  //   useEffect(() => {
  //           if (editdata?.airlinepayloadData?.requestType){
  //             dispatch(clearSearchRateAvailableData());
  //           }

  // },[editdata])
  
  useEffect(() => {
    const payload = {
      queryId: queryId,
    };

    dispatch(getsinglebookingdata(payload))
      .then((res) => {
        // console.log(
        //   res?.payload?.data?.data,
        //   "Query ID saved successfully."
        // );
        setEditbookeditem(res?.payload?.data?.data);
        setEditPayload(
          res?.payload?.data?.data?.search_query_data ||
            editQueryData?.search_query_data
        );
        console.log(res?.payload?.data?.data, "Query ID saved successfully.",editQueryData?.search_query_data);
        setEditData(
          res?.payload?.data?.data?.search_query_data ||
            editQueryData?.search_query_data
        );
      })
      .catch((error) => {
        console.error("Error saving query ID:", error);
      });


    
  }, []);

  useEffect(() => {
      setTemperatureControl({
        tempraturerange: editdata?.airlinepayloadData?.temperatureRange,
        upperbound: editdata?.airlinepayloadData?.upperBound ,
        lowerbound: editdata?.airlinepayloadData?.lowerBound ,
      })
  },[editdata,editQueryData]);
  console.log(editdata, "editdata");

  const handlebackcomodity = async (commodityid) => {
    const token = cdutilsAirlineToken;

    console.log(commodityid, "commodityid");
    try {
      const response = await axios.get(
        `https://cdutils.sgate.net/api/v1/new/commoditydetails/${commodityid}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response?.data?.data[0], "response");
      const selectedcomodityoption = response?.data.data?.map((item) => ({
        value: item?.id,
        // value: item?.commodityCode,
        label: item?.commodity_description,
        QR_code: item?.QR_code,
        // productCode: item?.QR_productCode,
        // specialHandlingCodes: item?.QR_commodityShc,
        // commodityCode: item?.QR_commodityShc,
        commodity_description: item?.commodity_description,
      }));
      console.log(selectedcomodityoption, "selectedcomodityoption");
      comoditydatabasedonqr_code(selectedcomodityoption[0]);
    } catch (error) {}
  };
  useEffect(() => {
    // console.log(
    //   editdata?.airlinepayloadData?.commodityId,
    //   "editdata?.airlinepayloadData?.commodityId"
    // );
    if (searchFormData?.productDetails?.commodityId) {
      console.log(searchFormData?.productDetails?.commodityId);
      handlebackcomodity(searchFormData?.productDetails?.commodityId);
    } else if (editdata?.airlinepayloadData?.productDetails?.commodityId) {
      console.log(editdata?.airlinepayloadData?.commodityId);
      handlebackcomodity(editdata?.airlinepayloadData?.productDetails?.commodityId);
    }
    console.log(editdata, "editdata");
    // formikData?.setFieldValue("")
  }, [searchFormData, editdata]);
  const login = async () => {
    try {
      const payload = {
        username: "sgate.jasprits@gmail.com",
        password: "Sgate#9430",
      };
      console.log(payload);
      const response = await axios.post(
        `https://cdutils.sgate.net/api/v1/auth/login`,
        payload
      );   

      const token = response?.data?.token;
      cdutilsAirlineToken = token;
      setairlinetoken(token);
      if (token) {
        console.log("Token stored!");
        const response = await axios.get(
          `https://cdutils.sgate.net/api/v1/new/commoditylist`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("Commodity Data:", response.data);
        const comodityMasterOptions = response?.data.data?.map((item) => ({
          value: item?.id,
          // value: item?.commodityCode,
          label: item?.commodity_description,
          QR_code: item?.QR_code,
          // productCode: item?.QR_productCode,
          // specialHandlingCodes: item?.QR_commodityShc,
          // commodityCode: item?.QR_commodityShc,
          commodity_description: item?.commodity_description,
        }));
        setcomodityMaster(comodityMasterOptions);
      }
    } catch (err) {
      console.error("Login error:", err);
    }
  };

  // const comodityMasterData = async () => {
  //   try {
  //      const token = localStorage.getItem("tokenairline");
  //      console.log(token, "tokenairlinecomodity");

  //     return response.data;
  //   } catch (error) {
  //     console.error("Error fetching commodity data:", error);
  //     throw error;
  //   }
  // };

  const comoditydatabasedonqr_code = async (option) => {
    const token = cdutilsAirlineToken;

    if (token) {
      console.log("Token stored!", option);
      const qr_code = option?.QR_code;
      console.log(qr_code, "qr_code");
      const response = await axios.get(
        `https://cdutils.sgate.net/api/v1/new/qrcommodityinfo/${qr_code}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Commodity Data:", response.data);
      const data = response?.data?.data[0];
      let newdata;
      if (response?.data?.data.length > 1) {
        newdata = response?.data?.data?.filter((item) => {
          return item?.productCode === "GCR";
        });
        console.log(newdata, "newdata");
      }

      const productdetail1 = {
        commodityCode: newdata?.[0]?.commodityCode
          ? newdata?.[0]?.commodityCode
          : data?.commodityCode,
        dgShipment: false,
        natureOfGoods: option?.commodity_description,
        productCode: newdata?.[0]?.productCode
          ? newdata?.[0]?.productCode
          : data?.productCode,
        commodityId: option?.value,
        specialHandlingCodes: [
          newdata?.[0]?.commodityShc
            ? newdata?.[0]?.commodityShc
            : data?.commodityShc,
        ],
      };
      console.log(productdetail1, "productdetail1");
      setProductDetails(productdetail1);
      console.log(option, "option");
      setCommodityid(option?.value);
    }
  };
  useEffect(() => {
    login();
  }, []);
  console.log("editdata", editdata);
  const handlemodalclose = () => {
    setIsOpen(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPopForm(null);
    // console.log(popForm);
  };
  // let specialcargo = {};

  // if (
  //   searchFormData?.searchquery?.goodsDetails.commonditytype
  //     .commonditytypesub === "Dangerous Goods"
  // ) {
  //   specialcargo = {
  //     dangerousgoods: {
  //       DGcommodityname: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.dangerousgoods?.DGcommodityname
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGcommodityname
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGcommodityname
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGcommodityname
  //         : "",
  //       DGhscode: searchFormData?.searchquery?.goodsDetails.commonditytype
  //         ?.specialcargo?.dangerousgoods?.DGhscode
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGhscode
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGhscode
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGhscode
  //         : "",
  //       DGclassdescription: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.dangerousgoods?.DGclassdescription
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGclassdescription
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGclassdescription
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGclassdescription
  //         : "",
  //       DGpackinggroup: searchFormData?.searchquery?.goodsDetails.commonditytype
  //         ?.specialcargo?.dangerousgoods?.DGpackinggroup
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGpackinggroup
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGpackinggroup
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGpackinggroup
  //         : "",
  //       DGspecialinstructions: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.dangerousgoods?.DGspecialinstructions
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.dangerousgoods?.DGspecialinstructions
  //         : editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGspecialinstructions
  //         ? editdata?.goodsDetails.commonditytype?.specialcargo?.dangerousgoods
  //             ?.DGspecialinstructions
  //         : "",
  //       DGmsdsfile: editdata?.DGmsdsfile ? editdata?.DGmsdsfile : "",
  //       DGpackinglistfile: editdata?.DGpackinglistfile
  //         ? editdata?.DGpackinglistfile
  //         : "",
  //     },
  //   };
  // }
  //  else if (
  //   searchFormData?.searchquery?.goodsDetails.commonditytype
  //     .commonditytypesub === "Temperature Controlled / Pharma"
  // ) {
  //   specialcargo = {
  //     temperaturecontrolled: {
  //       TCtempereaturecontroledtype: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.temperaturecontrolled
  //         ?.TCtempereaturecontroledtype
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.temperaturecontrolled?.TCtempereaturecontroledtype
  //         : "",
  //       TCtemperaturecontrolrange: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.temperaturecontrolled
  //         ?.TCtemperaturecontrolrange
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.temperaturecontrolled?.TCtemperaturecontrolrange
  //         : "",
  //       TCspecialinstrictions: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.temperaturecontrolled
  //         ?.TCspecialinstrictions
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.temperaturecontrolled?.TCspecialinstrictions
  //         : "",
  //       TCpackinglistfile: "",
  //     },
  //   };
  // } else if (
  //   searchFormData?.searchquery?.goodsDetails.commonditytype
  //     .commonditytypesub === "Other Special Commodity"
  // ) {
  //   specialcargo = {
  //     specialcommodity: {
  //       OSotherspecialcommoditytype: searchFormData?.searchquery?.goodsDetails
  //         .commonditytype?.specialcargo?.specialcommodity
  //         ?.OSotherspecialcommoditytype
  //         ? searchFormData?.searchquery?.goodsDetails.commonditytype
  //             ?.specialcargo?.specialcommodity?.OSotherspecialcommoditytype
  //         : "",
  //     },
  //   };
  // }
  let PackagesInit = [];
  if (
    searchFormData?.searchquery?.packagingDetails?.packagingType?.packages
      ?.length > 0
  ) {
    searchFormData?.searchquery?.packagingDetails?.packagingType?.packages?.map(
      (item) => {
        // console.log("1366666666666666666", item);
        let obj = {
          units: item.units,
          length: item.length,
          width: item.width,
          height: item.height,
          unit: item.unit,
          weight: item.weight,
          weightunit: item.weightunit,
          packagetype: item.packagetype,
          handling: item.handling,
          totalsubunits: item.totalsubunits,
          totalsubweight: item.totalsubweight,
          totalsubvolume: item.totalsubvolume,
        };
        PackagesInit.push(obj);
        // console.log(obj);
      }
    );
  } else if (editdata?.packagingDetails?.packagingType?.packages?.length > 0) {
    editdata?.packagingDetails?.packagingType?.packages?.map((item) => {
      // console.log("1366666666666666666", item);
      let obj = {
        units: item.units,
        length: item.length,
        width: item.width,
        height: item.height,
        unit: item.unit,
        weight: item.weight,
        weightunit: item.weightunit,
        packagetype: item.packagetype,
        handling: item.handling,
        totalsubunits: item.totalsubunits,
        totalsubweight: item.totalsubweight,
        totalsubvolume: item.totalsubvolume,
      };
      PackagesInit.push(obj);
      // console.log(obj);
    });
  } else {
    PackagesInit.push({
      units: "",
      length: "",
      width: "",
      height: "",
      unit: "CM",
      weight: "",
      weightunit: "KG/UNIT",
      packagetype: "Box",
      handling: "Tiltable and Stackable",
      totalsubunits: "",
      totalsubweight: "",
      totalsubvolume: "",
      Temp: "",
    });
  }
  // console.log("searchFormData", searchFormData?.queryId);
  //   console.log("editdatainitialvalue",editdata)
  const initialValues = {
    cargoType: searchBy,

    originAirport: {
      originAirport: searchFormData?.searchquery?.originAirport.originAirport
        ? searchFormData?.searchquery?.originAirport.originAirport
        : editdata?.originAirport?.originAirport
        ? editdata?.originAirport?.originAirport
        : "",
      originLocation: searchFormData?.searchquery?.originAirport.originLocation
        ? searchFormData?.searchquery?.originAirport.originLocation
        : editdata?.originAirport?.originLocation
        ? editdata?.originAirport?.originLocation
        : "",
      originPickup: searchFormData?.searchquery?.originAirport.originPickup
        ? true
        : false || editdata?.originAirport?.originPickup
        ? editdata?.originAirport?.originPickup
        : false,
      // originVehicleType: selectedVehicle.originVehicle,
      // originVehicleType:selectedVehicle?.originVehicle,
      //   pickupToOriginAirportDistance:originDistance?parseFloat(originDistance):0,
      originLocationMarker: searchFormData?.searchquery?.originAirport
        .originLocationMarker
        ? searchFormData?.searchquery?.originAirport.originLocationMarker
        : editdata?.originAirport?.originLocationMarker
        ? editdata?.originAirport?.originLocationMarker
        : {},
      originPortMarker: searchFormData?.searchquery?.originAirport
        .originPortMarker
        ? searchFormData?.searchquery?.originAirport.originPortMarker
        : editdata?.originAirport?.originPortMarker
        ? editdata?.originAirport?.originPortMarker
        : {},
      originLocationCountry: searchFormData?.searchquery?.originAirport
        .originLocationCountry
        ? searchFormData?.searchquery?.originAirport.originLocationCountry
        : editdata?.originAirport?.originLocationCountry
        ? editdata?.originAirport?.originLocationCountry
        : "",
      origincityName: searchFormData?.searchquery?.originAirport?.origincityName
        ? searchFormData?.searchquery?.originAirport?.origincityName
        : editdata?.originAirport?.origincityName
        ? editdata?.originAirport?.origincityName
        : "",
      origincountryName: searchFormData?.origincountryName
        ? searchFormData?.origincountryName
        : editdata?.originAirport?.origincountryName
        ? editdata?.originAirport?.origincountryName
        : "",
    },
    destinationAirport: {
      destinationAirport: searchFormData?.searchquery?.destinationAirport
        .destinationAirport
        ? searchFormData?.searchquery?.destinationAirport.destinationAirport
        : editdata?.destinationAirport?.destinationAirport
        ? editdata?.destinationAirport?.destinationAirport
        : "",
      destinationLocation: searchFormData?.searchquery?.destinationAirport
        .destinationLocation
        ? searchFormData?.searchquery?.destinationAirport.destinationLocation
        : editdata?.destinationAirport?.destinationLocation
        ? editdata?.destinationAirport?.destinationLocation
        : "",
      destinationPickup: searchFormData?.searchquery?.destinationAirport
        .destinationPickup
        ? true
        : false || editdata?.destinationAirport?.destinationPickup
        ? editdata?.destinationAirport?.destinationPickup
        : false,
      // destionationVehicleType: selectedVehicle.destinationVehicle,
      // destionationVehicleType:selectedVehicle?.destinationVehicle,
      // pickupToDestionationAirportDistance:destinationDistance?parseFloat(destinationDistance):0,
      destinationLocationMarker: searchFormData?.searchquery?.destinationAirport
        .destinationLocationMarker
        ? searchFormData?.searchquery?.destinationAirport
            .destinationLocationMarker
        : editdata?.destinationAirport?.destinationLocationMarker
        ? editdata?.destinationAirport?.destinationLocationMarker
        : {},
      destinationPortMarker: searchFormData?.searchquery?.destinationAirport
        .destinationPortMarker
        ? searchFormData?.searchquery?.destinationAirport.destinationPortMarker
        : editdata?.destinationAirport?.destinationPortMarker
        ? editdata?.destinationAirport?.destinationPortMarker
        : {},
      destinationLocationCountry: searchFormData?.searchquery
        ?.destinationAirport.destinationLocationCountry
        ? searchFormData?.searchquery?.destinationAirport
            .destinationLocationCountry
        : editdata?.destinationAirport?.destinationLocationCountry
        ? editdata?.destinationAirport?.destinationLocationCountry
        : "",
      destinationcityName: searchFormData?.searchquery?.destinationAirport
        .destinationcityName
        ? searchFormData?.searchquery?.destinationAirport.destinationcityName
        : editdata?.destinationAirport?.destinationcityName
        ? editdata?.destinationAirport?.destinationcityName
        : "",
      destinationcountryName: searchFormData?.searchquery?.destinationAirport
        .destinationcountryName
        ? searchFormData?.searchquery?.destinationAirport.destinationcountryName
        : editdata?.destinationAirport?.destinationcountryName
        ? editdata?.destinationAirport?.destinationcountryName
        : "",
    },
    goodsDetails: {
      cargoreadydate: searchFormData?.searchquery?.goodsDetails.cargoreadydate
        ? searchFormData?.searchquery?.goodsDetails.cargoreadydate
        : editdata?.goodsDetails?.cargoreadydate
        ? editdata?.goodsDetails?.cargoreadydate
        : dayjs().add(1, "day").format("DD/MM/YYYY"),
      // commonditytype: {
      //   commonditytype: searchFormData?.searchquery?.goodsDetails.commonditytype
      //     .commonditytype
      //     ? searchFormData?.searchquery?.goodsDetails.commonditytype
      //         .commonditytype
      //     : editdata?.goodsDetails?.commonditytype?.commonditytype ||
      //       "General Cargo",
      //   commonditytypesub: searchFormData?.searchquery?.goodsDetails
      //     .commonditytype.commonditytypesub
      //     ? searchFormData?.searchquery?.goodsDetails.commonditytype
      //         .commonditytypesub
      //     : editdata?.goodsDetails?.commonditytype?.commonditytypesub || "All",

      //   generalcargo: {
      //     generalgoods: editdata?.goodsDetails?.commonditytype?.generalcargo
      //       ?.generalgoods
      //       ? editdata?.goodsDetails?.commonditytype?.generalcargo?.generalgoods
      //       : "All",
      //   },
      //   specialcargo,
      // },
    },
    commodityCode: "",
    commodityId:
      searchFormData?.productDetails?.commodityId ||
      editdata?.airlinepayloadData?.productDetails?.commodityId ||
      "",
    commodity_description:
      searchFormData?.productDetails?.commodity_description ||
      editdata?.airlinepayloadData?.productDetails?.natureOfGoods ||
      "",
    temperatureRange:  searchFormData?.searchquery?.temperatureRange || editdata?.airlinepayloadData?.temperatureRange || "",
    uppertempbound: searchFormData?.searchquery?.uppertempbound || editdata?.airlinepayloadData?.uppertempbound || "",
    lowertempbound: searchFormData?.searchquery?.lowertempbound || editdata?.airlinepayloadData?.lowertempbound || "",
    packagingDetails: {
      packagingDetailsBy: searchFormData?.searchquery?.packagingDetails
        .packagingDetailsBy
        ? searchFormData?.searchquery?.packagingDetails.packagingDetailsBy
        : editdata?.packagingDetails?.packagingDetailsBy
        ? editdata?.packagingDetails?.packagingDetailsBy
        : "Packaging Type",
      shipmentTotal: {
        totalunits: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.totalunits
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalunits
          : editdata?.packagingDetails?.shipmentTotal?.totalunits
          ? editdata?.packagingDetails?.shipmentTotal?.totalunits
          : "",
        totalvolume: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.totalvolume
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalvolume
          : editdata?.packagingDetails?.shipmentTotal?.totalvolume
          ? editdata?.packagingDetails?.shipmentTotal?.totalvolume
          : "",
        unit: searchFormData?.searchquery?.packagingDetails?.shipmentTotal?.unit
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal.unit
          : editdata?.packagingDetails?.shipmentTotal?.unit
          ? editdata?.packagingDetails?.shipmentTotal?.unit
          : "CBM",
        totalweight: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.totalweight
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalweight
          : editdata?.packagingDetails?.shipmentTotal?.totalweight
          ? editdata?.packagingDetails?.shipmentTotal?.totalweight
          : "",
        weightunit: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.weightunit
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .weightunit
          : editdata?.packagingDetails?.shipmentTotal?.weightunit
          ? editdata?.packagingDetails?.shipmentTotal?.weightunit
          : "KG",
        totalpackagetype: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.totalpackagetype
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .totalpackagetype
          : editdata?.packagingDetails?.shipmentTotal?.totalpackagetype
          ? editdata?.packagingDetails?.shipmentTotal?.totalpackagetype
          : "Box",
        handling: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.handling
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal.handling
          : editdata?.packagingDetails?.shipmentTotal?.handling
          ? editdata?.packagingDetails?.shipmentTotal?.handling
          : "Tiltable and Stackable",
        packinglistfile: editdata?.packagingDetails?.shipmentTotal
          ?.packinglistfile
          ? editdata?.packagingDetails?.shipmentTotal?.packinglistfile
          : "",
        weightless: searchFormData?.searchquery?.packagingDetails?.shipmentTotal
          ?.weightless
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .weightless
          : editdata?.packagingDetails?.shipmentTotal?.weightless
          ? editdata?.packagingDetails?.shipmentTotal?.weightless
          : "",
        dimensionless: searchFormData?.searchquery?.packagingDetails
          ?.shipmentTotal?.dimensionless
          ? searchFormData?.searchquery?.packagingDetails.shipmentTotal
              .dimensionless
          : editdata?.packagingDetails?.shipmentTotal?.dimensionless
          ? editdata?.packagingDetails?.shipmentTotal?.dimensionless
          : "",
      },
      packagingType: {
        packages: editdata?.packagingDetails?.packagingType?.PackagesInit
          ? editdata?.packagingDetails?.packagingType?.PackagesInit
          : PackagesInit,
        totalunits: searchFormData?.searchquery?.packagingDetails?.packagingType
          ?.totalunits
          ? searchFormData?.searchquery?.packagingDetails.packagingType
              .totalunits
          : editdata?.packagingDetails?.packagingType?.totalunits
          ? editdata?.packagingDetails?.packagingType?.totalunits
          : "",
        totalvolume: searchFormData?.searchquery?.packagingDetails
          ?.packagingType?.totalvolume
          ? searchFormData?.searchquery?.packagingDetails.packagingType
              .totalvolume
          : editdata?.packagingDetails?.packagingType?.totalvolume
          ? editdata?.packagingDetails?.packagingType?.totalvolume
          : "",
        totalweight: searchFormData?.searchquery?.packagingDetails
          ?.packagingType?.totalweight
          ? searchFormData?.searchquery?.packagingDetails.packagingType
              .totalweight // here to change the code to set value in the packagetype outer value in the form
          : editdata?.packagingDetails?.packagingType?.totalweight
          ? editdata?.packagingDetails?.packagingType?.totalweight
          : "",
      },
    },
    paymentTerms: {
      paymentType: searchFormData?.searchquery?.paymentTerms.paymentType
        ? searchFormData?.searchquery?.paymentTerms.paymentType
        : editdata?.paymentTerms?.paymentType
        ? editdata?.paymentTerms?.paymentType
        : "Prepaid",
      incoTerms: searchFormData?.searchquery?.paymentTerms.incoTerms
        ? searchFormData?.searchquery?.paymentTerms.incoTerms
        : editdata?.paymentTerms?.incoTerms
        ? editdata?.paymentTerms?.incoTerms
        : "",
      optionalVas: searchFormData?.searchquery?.paymentTerms?.optionalVas
        ? searchFormData?.searchquery?.paymentTerms?.optionalVas
        : editdata?.paymentTerms?.optionalVas
        ? editdata?.paymentTerms?.optionalVas
        : [],
    },
  };
  // console.log("initialValues", initialValues);
  const validationSchema = Yup.object().shape({
    originAirport: Yup.object().shape({
      originAirport: Yup.string().required("Origin Airport is required"),
    }),
    destinationAirport: Yup.object().shape({
      destinationAirport: Yup.string().required(
        "Destination Airport is required"
      ),
    }),
    // goodsDetails: Yup.object().shape({
    //   commonditytype: Yup.object().shape({
    //     commonditytype: Yup.string().required("Goods Details is required"),
    //   }),
    // }),
    // packagingDetails: Yup.object().shape({
    //   packagingDetailsBy: Yup.string().required("Packing Details is required"),
    // }),
    // packagingDetails: Yup.object().shape({
    //   packagingDetailsBy: Yup.string()
    //     .required("Packaging Details is required")
    packagingDetails: Yup.object().shape({
      packagingDetailsBy: Yup.string().required(
        "Packaging Details is required"
      ),
      packagingType: Yup.object()
        .shape({
          totalunits: Yup.number(),
          totalweight: Yup.number(),
          totalvolume: Yup.number(),
        })
        .test(
          "check-packaging",
          "Total units, weight, and volume must be greater than 0",
          function (value) {
            const { totalunits, totalweight, totalvolume } = value || {};
            if (
              !totalunits ||
              totalunits <= 0 ||
              !totalweight ||
              totalweight <= 0 ||
              !totalvolume ||
              totalvolume <= 0
            ) {
              return this.createError({
                path: "packagingDetails.packagingType.totalunits",
                message:
                  "Total units, weight, and volume must be greater than 0",
              });
            }
            return true;
          }
        ),
    }),

    paymentTerms: Yup.object().shape({
      incoTerms: Yup.string().required("Payment Terms is required"),
      // optionalVas:Yup.array().min(1, "At least one service must be selected").required("Services selection is required"),
    }),
  });
  const open = Boolean(anchorEl);
  function findflights(values) {
    // console.log(
    //   values.searchquery.destinationAirport,
    //   values,
    //   values.searchquery.originAirport,
    //   "flightratevalues"
    // );

    values.searchquery = {
      ...values.searchquery,
      originAirport: {
        ...values.searchquery?.originAirport,
        originVehicleType:
          selectedVehicle?.originVehicle === ""
            ? originvehicle[0]?._id
            : selectedVehicle?.originVehicle,
        pickupToOriginAirportDistance: originDistance
          ? Number.parseFloat(originDistance)
          : 0,
      },
      destinationAirport: {
        ...values.searchquery?.destinationAirport,
        destionationVehicleType:
          selectedVehicle?.destinationVehicle === ""
            ? destinationvehicle[0]?._id
            : selectedVehicle?.destinationVehicle,
        pickupToDestionationAirportDistance: destinationDistance
          ? Number.parseFloat(destinationDistance)
          : 0,
      },
    };

    const bookingeditpayload = {
      airlinepayloadData: editpayload?.airlinepayloadData,
      cargoType: editpayload?.cargoType,
      destinationAirport: editpayload?.destinationAirport,
      goodsDetails: editpayload?.goodsDetails,
      originAirport: editpayload?.originAirport,
      packagingDetails: editpayload?.packagingDetails,
      paymentTerms: editpayload?.PaymentTerms,
    };
    // console.log(values,bookingeditpayload, "updated values");
    const payload = editpayload ? bookingeditpayload : values;

    if (searchFormData) {
      dispatch(clearSearchRateAvailableData());
    }
    setReceivingResponse({});
    console.log(values, "values", payload);
    dispatch(searchRateAnimation({ nodeData: values }));
    navigate("/search-rates/search-rates-result");

    // dispatch(searchrates(values))
    //   .then((res) => {
    //     // console.log(res, "res");
    //     // dispatch(setAirportData(res?.payload?.data))

    //     // navigate("/search-rates/search-rates-result");

    //     if (
    //       res?.payload?.success === "error" ||
    //       res?.payload?.statusCode === 500
    //     ) {
    //       console.error("Error response:", res.payload, error);
    //       // Set the error in the state
    //       setError(res?.payload?.success || "");
    //       // Redirect to the error page
    //     } else {
    //       // Proceed normally if no error
    //       navigate("/search-rates/search-rates-result");
    //     }
    //   })
    //   .catch((err) => {});
    // })
  }
  // console.log(finaldata,"finaldata")
  // function openmodal(values, msg, type) {
  //   Modal.confirm({
  //     title: msg,
  //     okText: "Proceed",
  //     cancelButtonProps: {
  //       style: {
  //         color: "#FFAF00",
  //         borderColor: "#FFAF00",
  //       },
  //     },
  //     onOk() {
  //       if (type === "origin") {
  //         values.originAirport.originPickup = false;
  //         values.originAirport.originLocation = "";
  //         values.originAirport.originLocationMarker = {};
  //         values.originAirport.originPortMarker = {};
  //         values.originAirport.originLocationCountry = "";
  //       } else if (type === "destination") {
  //         values.destinationAirport.destinationPickup = false;
  //         values.destinationAirport.destinationLocation = "";
  //         values.destinationAirport.destinationLocationMarker = {};
  //         values.destinationAirport.destinationPortMarker = {};
  //         values.destinationAirport.destinationLocationCountry = "";
  //       } else if (type === "thirdcountry") {
  //         values.originAirport.originPickup = false;
  //         values.originAirport.originLocation = "";
  //         values.destinationAirport.destinationPickup = false;
  //         values.destinationAirport.destinationLocation = "";
  //       }
  //       findflights(values);
  //     },
  //     onCancel() {},
  //     okButtonProps: {
  //       style: {
  //         color: "#ffffff",
  //         backgroundColor: "#FFAF00",
  //       },
  //     },
  //   });
  // }
  
  function Greeting({ formikData ,formik }) {
    console.log(formikData,"greetings")
    const onSubmit = (values) => {
    //    console.log(selectoption);
    // console.log(values,"values")
    // commodityformik.values()
  
// console.log(formikData,values,"greetings")

    // console.log("good details", values);
    setAnchorEl(null);
  };
const handlechange = (date) => {
  const formatted = date ? dayjs(date).format("DD/MM/YYYY") : "";
  formikData?.setFieldValue("goodsDetails.cargoreadydate", formatted);
  setSelectedDate(formatted);
//   const [selecteddate,setSelectedDate] = useState("")
};


  //  const disabledDate = (current) => {
  //    return current && current < dayjs().endOf("day");
  //  };

const disabledDate = (current) => {
  if (!current) return false;
  
  const today = dayjs().startOf("day");
  const oneMonthFromToday = dayjs().add(1, "month").endOf("day");
  
  // Only disable dates before today - allow all future dates up to 1 month
  return current.isBefore(today, "day") || current.isAfter(oneMonthFromToday, "day");
};
  // Get the current date value
const currentDate = selecteddate? selecteddate : formikData?.values?.goodsDetails?.cargoreadydate;

const dateValue = currentDate
  ? dayjs(currentDate, "DD/MM/YYYY")
  : null; // empty until user selects

 
  return (
    <>
      <div className="grid grid-cols-5 gap-6 w-full p-2">
        {/* DatePicker */}
        <div className="col-span-1">
          <label
            htmlFor="cargoreadydate"
            className="py-2 block text-sm font-bold leading-5 text-formlabel"
          >
            Cargo Ready Date*
          </label>
         <DatePicker
  name="cargoreadydate"
  id="cargoreadydate"
  value={dateValue}
  onChange={handlechange}
  allowClear={false}
  format="DD/MM/YYYY"
  popupStyle={{ zIndex: 9999 }}
  className="w-fit p-2"
  disabledDate={disabledDate}
/>

        </div>
    {/* <GoodDetails  formikData={commodityformik} setAnchorEl={setAnchorEl} /> */}

   <div className="overflow-visible col-span-3">
                    <label
                      htmlFor="commonditytype"
                      className="py-2 block text-sm font-bold leading-5 text-formlabel"
                    >
                      Commodity Type1*
                    </label>
                   {/* {console.log(formikData?.values?.commodityId,formik,"formikData?.values?.commodityId")} */}
              {/* { console.log(formikData.values,"abcd")}  */}
                   <Select
                      options={comodityMaster}
                      value={ comodityMaster.find(
                        (option) =>
                          parseInt(option?.value) ===selectedcomondity
                          // parseInt(null)
                      )
                       }
                       defaultValue={comodityMaster.find(
                        (option) =>{
                          const selectedid=parseInt(option?.value) ===
                       formikData.values.commodityId?  parseInt(formikData.values.commodityId): parseInt("98")
                       console.log(selectedid,"selectedid")
                        return   selectedid
                          }   )}
                      onChange={(option) => {
                        console.log('opt',option)
                        comoditydatabasedonqr_code(option);
                        formikData.setFieldValue("commodityId", option.value);
                          // const [selectedcomondity,setSelectedComondity] = useState("")
setSelectedComondity(option.value)
                        //  formik.setFieldValue()s
                        // https://cdutils.sgate.net/api/v1/new/commoditydetails/93
                        // const [productDetails, setProductDetails] = useState({});
                        //   const [commodityid, setCommodityid] = useState("");

                        // getCommodityDetail(option.value, setFieldValue);
                        // setFieldValue(
                        //   "commodity_description",
                        //   option?.commodity_description
                        // );
                        // setFieldValue("commodityCode", option.commodityCode),
                        //   setFieldValue("commodityId", option.value),
                        //   setFieldValue("commodityDetails", option.label);
                        // setFieldValue("productCode", option.productCode);
                        // setFieldValue(
                        //   "specialHandlingCodes",
                        //   option.specialHandlingCodes
                        // );
                        // if (option?.productCode !== "QFR") {
                        //   formik?.values ?. setFieldValue("temperatureRange", "");
                        //    formik?.values ?. setFieldValue("lowertempbound", "");
                        //     formik?.values ?. setFieldValue("uppertempbound", "");
                        // }
                      }}
                      className="w-full"
                    />
                    {/* <ErrorMessage
                      name="commodityId"
                      component="div"
                      className="text-red-600 text-sm mt-1"
                    /> */}
                    {productDetails?.productCode === "QFR" && (
                      <div className="mt-4">
                        <div className="flex items-center space-x-6">
                          <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
                            Select Temperature Range:
                          </label>

                        
                          {[
                            { label: "2-8°C", value: "2-8" },
                            { label: "15-25°C", value: "15-25" },
                            { label: "2-25°C", value: "2-25" },
                          ].map((range) => {
                            const [lower, upper] = range.value
                              .split("-")
                              .map(Number);

                            const isChecked =
                              temperaturecontrol.tempraturerange ===
                              range.value;

                            return (
                              <label
                                key={range.value}
                                className="inline-flex items-center cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  name="tempraturerange"
                                  value={range.value}
                                  checked={isChecked}
                                  onChange={() => {
                                    if (isChecked) {
                                      setTemperatureControl({
                                        tempraturerange: "",
                                        lowerbound: "",
                                        upperbound: "",
                                      });
                                    } else {
                                      setTemperatureControl({
                                        tempraturerange: range.value,
                                        lowerbound: lower,
                                        upperbound: upper,
                                      });
                                      formikData?.setFieldValue(
                                        "temperatureRange",
                                        range.value
                                      );
                                      formikData.setFieldValue(
                                        "lowertempbound",
                                        lower
                                      );
                                      formikData.setFieldValue(
                                        "uppertempbound",
                                        upper
                                      );
                                    }
                                  }}
                                  className="form-radio text-blue-600 h-4 w-4"
                                />

                                <span className="ml-2 text-sm font-medium text-gray-700">
                                  {range.label}
                                </span>
                              </label>
                            );
                          })}
                        </div>
                        {/* {tempraturerangeerror && (
                                        <p className="text-red-600 text-sm mt-1">
                                          Please select temperature range
                                        </p>
                                      )} */}
                        {/* <ErrorMessage
                                        name="temperatureRange"
                                        component="div"
                                        className="text-red-600 text-sm mt-1"
                                      /> */}
                      </div>
                    )}
                    {/* <Field component={CustomRadioGroup} name="commonditytype.commonditytype" selectOptions={CommodityType}  radioVal={radioVal} setRadioVal={setRadioVal}/> */}
                  </div>

                  
  </div>
    <div className="col-span-12 mt-32 mr-4 flex items-end justify-end sm:justify-center gap-5">
                     <button
                       type="button"
                       onClick={() => {
                         setAnchorEl(null);
                       }}
                       className="text-primary bg-white hover:bg-secondary hover:text-white font-bold leading-4 rounded-lg text-sm px-4 py-2 text-center  flex items-center justify-center gap-2 shadow-searchbox border-2 border-primary"
                     >
                       <CloseOutlined />
                       <span>Cancel</span>
                     </button>
                     <button
                     onClick={onSubmit}
                       className="text-white bg-primary hover:bg-secondary font-bold leading-4 rounded-lg text-sm px-4 py-2.5 text-center  flex items-center justify-center gap-2 shadow-searchbox"
                     >
                       <CheckOutlined />
                       <span>Confirm</span>
                     </button>
                   </div>
  </>  ) 
}

  // console.log(editbookeditem,"editbookeditem123445")
  // const {bookingType}=editbookeditem
  // console.log(bookingType,"editbookeditem");
  const onSubmit = (values, setprops) => {
    console.log(editbookeditem, "editbookediteminner");
    console.log(commodityid, "commodityid");
    if (type === "kam_admin") return;
    // console.log(
    //   values,
    //   values?.destinationAirport.destinationcountryName,
    //   "totalweightvalues",
    //   formikData
    // );

    // console.log(
    //   "data",
    //   destinationairport,
    //   destinationlocation,
    //   originairport,
    //   originlocation
    // );
    // console.log(values, "onsubmit of flight rate");
    // console.log(values.destinationAirport.destinationPickup
    //   ,values.originAirport.originPickup        ,"flightratevalues");
    // console.log(values, "origincountrynamevalues");
    const { shipmentTotal, packagingType } = values?.packagingDetails;
    const payloadParams = {
      searchquery: {
        cargoType: values.cargoType,
        ...values,
      },
    
      productDetails: productDetails,
      // commodity_description: productDetails?.natureOfGoods,
      ratePreference: {
        currencyCode: "INR",
      },
      routingPreference: {
        fetchAvailForNextXDays: 4,
        scheduledDepartureDate: moment(
          values?.goodsDetails?.cargoreadydate,
          "DD/MM/YYYY"
        ).format("DD-MMM-YYYY"),
      },
      commodity_id: commodityid,
      commodityId: commodityid,
      commodity_description: productDetails?.natureOfGoods,
      temperatureRange: temperaturecontrol?.tempraturerange,
      uppertempbound: temperaturecontrol?.upperbound,
      lowertempbound: temperaturecontrol?.lowerbound,
      origin: values?.originAirport?.originAirport.match(/\((.*?)\)/)[1],
      destination:
        values?.destinationAirport?.destinationAirport.match(/\((.*?)\)/)[1],
      origincityName: values?.originAirport.origincityName,
      origincountryName: values?.originAirport?.origincountryName,
      destinationcityName: values?.destinationAirport?.destinationcityName,
      destinationcountryName:
        values?.destinationAirport?.destinationcountryName,
      commodityDetails: productDetails?.natureOfGoods,
      productCode: productDetails?.productCode,
      specialHandlingCodes: productDetails?.specialHandlingCodes,
      calculatedType: 1,
      // getQPlusMode: 0,
      shipmentDimensions: packagingType?.packages?.map((item) => {
        const {
          length,
          width,
          height,
          units,
          weight,
          totalsubweight,
          totalsubvolume,
          handling,
        } = item;
        return {
          numberOfPieces: +units,
          length: +length,
          width: +width,
          height: +height,
          dimensionsUnit: "C",
          weightPerPiece: +weight,
          weightUnit: "KG",
          turnable: false,
          volumeWeight: +totalsubvolume,
          chargableWeight: +totalsubweight,
          stackable: checkStackableandTurnable(handling).stackable,
          turnable: checkStackableandTurnable(handling).turnable,
        };
      }),
      shipmentQuantityDetails: {
        chargeableWeight: +shipmentTotal?.totalweight,
        chargeableWeightUnit: "KG",
        totalPieces: +shipmentTotal?.totalunits,
        totalVolume: +shipmentTotal?.totalvolume,
        totalWeight: +shipmentTotal?.totalweight,
        volumeUnit: "CBM",
        weightUnit: "KG",
        total_vol_wt: +shipmentTotal?.totalvolume,
      },
      // requestType:searchFormData?.requestType==="1"?"2": "1",
      requestType:
        editQueryData != null
          ? "1"
          : editdata?.airlinepayloadData?.requestType
          ? "2"
          : "1",
      apiCall: "WEB",
    };
    if (searchFormData?.queryId) {
      payloadParams.queryId = searchFormData?.queryId;
    }
    if (searchFormData?.bookingId) {
      // console.log(searchFormData?.bookingId, "hgh");
      payloadParams.bookingId = searchFormData?.bookingId;
    }
    if (queryId) {
      payloadParams.bookingId = editbookeditem?.bookeditem?.bookingId;
      payloadParams.queryId = queryId;
    }
    // console.log(editbookeditem?.bookeditem?.productOffers?.convId,searchFormData,"editbookeditem?.bookeditem?.productOffers?.convId")
    // if(editbookeditem?.bookeditem?.productOffers?.convId){
    //   payloadParams.convId=editbookeditem?.bookeditem?.productOffers?.convId
    // }
    // ?.search_query_data?.airlinepayloadData?.bookingType||editbookeditem?.bookingType
    if (editbookeditem) {
      console.log("editbooking", editbookeditem);
      payloadParams.bookingType = editbookeditem?.bookingType? editbookeditem?.bookingType:editbookeditem?.search_query_data?.airlinepayloadData?.bookingType;
      payloadParams.airWaybillNumber =
        editbookeditem?.bookeditem?.airWaybillNumber; // for the frieghtos update case only
      payloadParams.convId = editbookeditem?.bookeditem?.productOffers?.convId;
      payloadParams.queryId = editbookeditem?.queryId;
      payloadParams.flightitinaries =
        editbookeditem?.bookeditem?.flightItineraries;
      payloadParams.booking_status = editbookeditem?.booking_status;
    }

    console.log(
      editbookeditem?.bookeditem?.bookingId,
      queryId,
      "editdataserchformdata"
    );
    console.log(payloadParams, "payloadParams");
    if (
      values?.destinationAirport?.destinationPickup === true &&
      values?.originAirport?.originPickup === false &&
      values?.packagingDetails?.packagingType?.totalunits !== "" &&
      values?.packagingDetails?.packagingType?.totalvolume !== "" &&
      values?.packagingDetails?.packagingType?.totalweight !== ""
    ) {
      setIsOpen(true);
      setPopup("destination");
      setDestination(values.destinationAirport.destinationLocation);
      console.log(payloadParams, "payloadParams3");
      setSearchQuery(payloadParams);
      const destinationPayload = {
        origin: values?.destinationAirport?.destinationPortMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.destinationAirport?.destinationLocationMarker || {
          lat: 0,
          lng: 0,
        },
      };
      // setDistancePayload(destinationPayload);

      dispatch(caldistance(destinationPayload))
        .then((res) => {
          if (!res?.payload?.success || !res?.payload?.data) {
            setIsOpen(false);
            toast.error(res?.payload?.message || "Unable to calculate the distance from required pickup or destination");
            return;
          }
          setDestinationDistance(res?.payload?.data?.distance);
          const payloadvehicle = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle))
            .then((res) => {
              setDestinationVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (
      values.originAirport.originPickup === true &&
      values.destinationAirport.destinationPickup === false &&
      values?.packagingDetails?.packagingType?.totalunits !== "" &&
      values?.packagingDetails?.packagingType?.totalvolume !== "" &&
      values?.packagingDetails?.packagingType?.totalweight !== ""
    ) {
      setIsOpen(true);
      setPopup("origin");
      setOrigin(values.originAirport.originLocation);
      console.log(payloadParams, "payloadParams2");
      setSearchQuery(payloadParams);
      const originPayload = {
        origin: values?.originAirport?.originLocationMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.originAirport?.originPortMarker || {
          lat: 0,
          lng: 0,
        },
      };
      // setDistancePayload(originPayload);
      dispatch(caldistance(originPayload))
        .then((res) => {
          if (!res?.payload?.success || !res?.payload?.data) {
            setIsOpen(false);
            toast.error(res?.payload?.message || "Unable to calculate the distance from required pickup or destination");
            return;
          }
          setOriginDistance(res?.payload?.data?.distance);
          const payloadvehicle = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle))
            .then((res) => {
              setOriginVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (
      values.originAirport.originPickup === true &&
      values.destinationAirport.destinationPickup === true &&
      values?.packagingDetails?.packagingType?.totalunits !== "" &&
      values?.packagingDetails?.packagingType?.totalvolume !== "" &&
      values?.packagingDetails?.packagingType?.totalweight !== ""
    ) {
      setIsOpen(true);
      setPopup("both");
      setOrigin(values.originAirport.originLocation);
      setDestination(values.destinationAirport.destinationLocation);
      console.log(payloadParams, "payloadParams1");
      setSearchQuery(payloadParams);
      const originPayload = {
        origin: values?.originAirport?.originLocationMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.originAirport?.originPortMarker || {
          lat: 0,
          lng: 0,
        },
      };

      const destinationPayload = {
        origin: values?.destinationAirport?.destinationPortMarker || {
          lat: 0,
          lng: 0,
        },
        destination: values?.destinationAirport?.destinationLocationMarker || {
          lat: 0,
          lng: 0,
        },
      };

      // Call API for origin
      dispatch(caldistance(originPayload))
        .then((res) => {
          if (!res?.payload?.success || !res?.payload?.data) {
            setIsOpen(false);
            toast.error(res?.payload?.message || "Unable to calculate the distance from required pickup or destination");
            return;
          }
          setOriginDistance(res?.payload?.data?.distance);
          const payloadvehicle = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle))
            .then((res) => {
              setOriginVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });

      // Call API for destination
      dispatch(caldistance(destinationPayload))
        .then((res) => {
          if (!res?.payload?.success || !res?.payload?.data) {
            setIsOpen(false);
            toast.error(res?.payload?.message || "Unable to calculate the distance from required pickup or destination");
            return;
          }
          setDestinationDistance(res?.payload?.data?.distance);
          const payloadvehicle2 = {
            cbm: values.packagingDetails.shipmentTotal.totalvolume,
            weight: values.packagingDetails.shipmentTotal.totalweight,
            distance: parseFloat(res?.payload?.data?.distance), //in km
          };
          dispatch(vehicletype(payloadvehicle2))
            .then((res) => {
              setDestinationVehicle(res?.payload?.data);
              if (
                values.originAirport.originPickup === true &&
                values.destinationAirport.destinationPickup === true
              ) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.originPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: "",
                  originVehicle: res?.payload?.data?.[0]?._id,
                });
              } else if (values.originAirport.destinationPickup === true) {
                setSelectedVehicle({
                  destinationVehicle: res?.payload?.data?.[0]?._id,
                  originVehicle: "",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.log(payloadParams, "payloadParamselse");
      findflights(payloadParams);
    }
  };

  const handleDistanceAndVehicle = (airport, values, type) => {
    const payload = {
      origin: airport?.originLocationMarker || { lat: 0, lng: 0 },
      destination: airport?.originPortMarker || { lat: 0, lng: 0 },
    };

    dispatch(caldistance(payload))
      .then((res) => {
        if (!res?.payload?.success || !res?.payload?.data) {
          toast.error(res?.payload?.message || "Unable to calculate the distance from required pickup or destination");
          return;
        }

        if (type === "origin") setOriginDistance(res?.payload?.data?.distance);
        else setDestinationDistance(res?.payload?.data?.distance);

        const vehiclePayload = {
          cbm: values.packagingDetails.shipmentTotal.totalvolume,
          weight: values.packagingDetails.shipmentTotal.totalweight,
          distance: parseFloat(res?.payload?.data?.distance),
        };

        return dispatch(vehicletype(vehiclePayload));
      })
      .then((vehicleRes) => {
        // no-op — vehicle state set in the chained vehicletype dispatch above
      })
      .catch((error) => {
        console.error(`Error fetching ${type} distance and vehicle:`, error);
      });
  };

  useEffect(() => {
    if (allAirportsState?.allairports?.length > 0) {
      let optionData = [];
      allAirportsState?.allairports.map((item) => {
        // console.log(item,"origincountryname")
        return optionData.push({
          value: `${item.cityName} - (${item.code})`,
          label: `${item.cityName} - (${item.code})`,
          origincityName: item?.cityName,
          origincountryName: item?.countryName,
        });
      });
      setAirports(optionData);
    } else {
      dispatch(getallairports());
    }
  }, [dispatch, allAirportsState]);
  useEffect(() => {
    // setSelectedVehicle({ destinationVehicle: destinationvehicle[0]?._id, originVehicle: originvehicle[0]?._id });
    function handleResize() {
      if (window.innerWidth < 1024) {
        setWebOpen(false);
      } else {
        setWebOpen(true);
      }
    }
    window.addEventListener("resize", handleResize);
    window.addEventListener("load", handleResize);
    handleResize();
  }, []);
  console.log(hasnodata, "hasnodata");
  useEffect(() => {
    if (hasnodata.statusCode === 500) {
      setError(hasnodata);
    }
  }, [hasnodata]);

  const handleproceed = () => {
    // console.log(selectedVehicle, initialValues, "selectedValue");

    console.log(searchquery, "searchquery");

    findflights(searchquery);
    setIsOpen(false);
  };
  // console.log(vehicle);
  // console.log(origin, destination, "origin & destination");
  console.log("error", error);
  return error === "error" ? (
    <FailureSearchRate />
  ) : (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formik, setFieldValue, setFieldTouched) => {
          console.log(formik, "formik");
          if(formik.values.goodsDetails?.cargoreadydate){
              // setFormikData(formik);
              setSelectedDate(formik.values.goodsDetails.cargoreadydate)
          }
          if(formik?.values?.commodityId){
            setSelectedComondity(formik?.values?.commodityId||"98")
          }
        
          return (
            <Form autoComplete="off">
              <div className="p-5  grid grid-cols-12 gap-4">
                <div className="sm:col-span-12 md:col-span-6 lg:col-span-6 col-span-3">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Origin Airport<span className="text-color-800">*</span>
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "OriginAirport")}
                    // className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-fit px-4 py-3 flex items-center justify-between gap-3"
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-3 py-3 flex items-center justify-between gap-0"
                  >
                    {formik.values.originAirport.originAirport ? (
                      <span className="text-formlabel">
                        {formik.values.originAirport.originAirport}
                      </span>
                    ) : (
                      <span>Select Origin / Search by Port name or code</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="originAirport.originAirport"
                    component={TextError}
                  />
                  <ErrorMessage
                    name="originAirport.originLocation"
                    component={TextError}
                  />
                </div>

                <div className="sm:col-span-12 md:col-span-6 lg:col-span-6 col-span-3">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Destination Airport<span className="text-red-800">*</span>
                  </p>
                  <div
                    onClick={(e) =>
                      handleClick(e, formik, "DestinationAirport")
                    }
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-3 py-3 flex items-center justify-between gap-0"
                  >
                    {formik.values.destinationAirport.destinationAirport ? (
                      <span className="text-formlabel">
                        {formik.values.destinationAirport.destinationAirport}
                      </span>
                    ) : (
                      <span>
                        Select Destination / Search by Port name or code
                      </span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="destinationAirport.destinationAirport"
                    component={TextError}
                  />
                  <ErrorMessage
                    name="destinationAirport.destinationLocation"
                    component={TextError}
                  />
                </div>

                <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-6">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Goods Details
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "GoodDetails")}
                // onChange={(e) => handlechangeforcommodity(e,formik)}

                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-5 py-3 flex items-center justify-between gap-3"
                  >
                    {/* {formik.values.goodsDetails.commonditytype
                      .commonditytype ? ( */}
                    <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-1">
                      <span className="bg-primary px-2.5 py-1 rounded-sm ">
                        {selecteddate? selecteddate : formikData?.values?.goodsDetails?.cargoreadydate}
                      </span>
                      <span className="bg-primary px-2.5 py-1 rounded-sm ">
                          {/* {
                            formik.values.goodsDetails
                            
                          } */}
                          {/* {productDetails?.natureOfGoods}
                          {
                            comodityMaster?.find(
                        (option) =>
                          parseInt(option.value) ===
                          parseInt(formikData?.values?.commodityId)
                      )

                          } */}


                            {
    comodityMaster?.find(
      (option) =>
        parseInt(option.value) === parseInt(formik?.values?.commodityId?formik?.values?.commodityId:editdata?.commodityId?editdata?.commodityId:98)
    )?.label
  }
                        </span>
                      {/* {formik.values.goodsDetails.commonditytype
                          .commonditytype === "General Cargo" ? (
                          // <span className="bg-primary px-2.5 py-1 rounded-sm ">
                          //   {
                          //     formik.values.goodsDetails.commonditytype
                          //       .generalcargo.generalgoods
                          //   }
                          // </span>
                          <span></span>
                        ) : (
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            {
                              formik.values.goodsDetails.commonditytype
                                .commonditytypesub
                            }
                          </span>
                        )} */}
                        
                    </div>
                    {/* ) : (
                      <span>Add Goods Details</span>
                    )} */}

                    
                    <RightOutlined />

                  </div>
                  {/* <ErrorMessage
                    name="goodsDetails.commonditytype.commonditytype"
                    component={TextError}
                  /> */}
{/* { comodity type working } */}
                  {/* <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-6">
                    <label
                      htmlFor="commonditytype"
                      className="py-2 block text-sm font-bold leading-5 text-formlabel"
                    >
                      Commodity Type*
                    </label>

                    <Select
                      options={comodityMaster}
                      value={comodityMaster.find(
                        (option) =>
                          parseInt(option.value) ===
                          parseInt(formik?.values?.commodityId)
                      )}
                      onChange={(option) => {
                        comoditydatabasedonqr_code(option);
                        formik.setFieldValue("commodityId", option.value);
                        // https://cdutils.sgate.net/api/v1/new/commoditydetails/93
                        // const [productDetails, setProductDetails] = useState({});
                        //   const [commodityid, setCommodityid] = useState("");

                        // getCommodityDetail(option.value, setFieldValue);
                        // setFieldValue(
                        //   "commodity_description",
                        //   option?.commodity_description
                        // );
                        // setFieldValue("commodityCode", option.commodityCode),
                        //   setFieldValue("commodityId", option.value),
                        //   setFieldValue("commodityDetails", option.label);
                        // setFieldValue("productCode", option.productCode);
                        // setFieldValue(
                        //   "specialHandlingCodes",
                        //   option.specialHandlingCodes
                        // );
                        // if (option?.productCode !== "QFR") {
                        //   formik?.values ?. setFieldValue("temperatureRange", "");
                        //    formik?.values ?. setFieldValue("lowertempbound", "");
                        //     formik?.values ?. setFieldValue("uppertempbound", "");
                        // }
                      }}
                      className="w-full"
                    />
                    <ErrorMessage
                      name="commodityId"
                      component="div"
                      className="text-red-600 text-sm mt-1"
                    />
                    {productDetails?.productCode === "QFR" && (
                      <div className="mt-4">
                        <div className="flex items-center space-x-6">
                          <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
                            Select Temperature Range:
                          </label>

                          {/* {[
                                          { label: "2-8°C", value: "2-8" },
                                          { label: "15-25°C", value: "15-25" },
                                          { label: "2-25°C", value: "2-25" },
                                        ]?.map((range) => (
                                          <label
                                            key={range.value}
                                            className="inline-flex items-center cursor-pointer"
                                          >
                                            <input
                                              type="checkbox"
                                              name="temperatureRange"
                                              value={range.value}
                                              // checked={range.value}
                                              onChange={() => {
                                                console.log(
                                                  range.value,
                                                  "range.value",formik?.values?.temperatureRange
                                                )
                                              //   if (formik?.values?.temperatureRange === range.value) {
                                              //     setFieldValue("temperatureRange", "");
                                              //     setFieldValue("lowertempbound", "");
                                              //     setFieldValue("uppertempbound", "");
                                              //   } else {
                                              //     const [lower, upper] = range.value
                                              //       .split("-")
                                              //       .map(Number);
                                              //     setFieldValue("temperatureRange", range.value);
                                              //     setFieldValue("lowertempbound", lower);
                                              // setFieldValue("uppertempbound", upper);
                                              //   }
                                              }}
                                              onBlur={() =>
                                              setFieldTouched("temperatureRange", true)
                                              }
                                              className="form-radio text-blue-600 h-4 w-4"
                                            />
                                            <span className="ml-2 text-sm font-medium text-gray-700">
                                              {range.label}
                                            </span>
                                          </label>
                                        ))} */}
                          {/* {[
                            { label: "2-8°C", value: "2-8" },
                            { label: "15-25°C", value: "15-25" },
                            { label: "2-25°C", value: "2-25" },
                          ].map((range) => {
                            const [lower, upper] = range.value
                              .split("-")
                              .map(Number);

                            const isChecked =
                              temperaturecontrol.tempraturerange ===
                              range.value;

                            return (
                              <label
                                key={range.value}
                                className="inline-flex items-center cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  name="tempraturerange"
                                  value={range.value}
                                  checked={isChecked}
                                  onChange={() => {
                                    if (isChecked) {
                                      setTemperatureControl({
                                        tempraturerange: "",
                                        lowerbound: "",
                                        upperbound: "",
                                      });
                                    } else {
                                      setTemperatureControl({
                                        tempraturerange: range.value,
                                        lowerbound: lower,
                                        upperbound: upper,
                                      });
                                      formik?.setFieldValue(
                                        "temperatureRange",
                                        range.value
                                      );
                                      formik.setFieldValue(
                                        "lowertempbound",
                                        lower
                                      );
                                      formik.setFieldValue(
                                        "uppertempbound",
                                        upper
                                      );
                                    }
                                  }}
                                  className="form-radio text-blue-600 h-4 w-4"
                                />

                                <span className="ml-2 text-sm font-medium text-gray-700">
                                  {range.label}
                                </span>
                              </label>
                            );
                          })} */}
                        </div>
                        {/* {tempraturerangeerror && (
                                        <p className="text-red-600 text-sm mt-1">
                                          Please select temperature range
                                        </p>
                                      )} */}
                        {/* <ErrorMessage
                                        name="temperatureRange"
                                        component="div"
                                        className="text-red-600 text-sm mt-1"
                                      /> */}
                      {/* </div> */}
                    {/* )} */}
                    {/* <Field component={CustomRadioGroup} name="commonditytype.commonditytype" selectOptions={CommodityType}  radioVal={radioVal} setRadioVal={setRadioVal}/> */}
                  {/* </div> */} 
                {/* </div> */}
                <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-5">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Packaging Details
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "PackagingDetails")}
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-5 py-3 flex items-center justify-between gap-3"
                  >
                    {formik.values.packagingDetails.packagingDetailsBy ? (
                      formik.values.packagingDetails.packagingDetailsBy ===
                      "Packaging Type" ? (
                        <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-1">
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Quantity:{" "}
                            {formik.values.packagingDetails?.packagingType
                              ?.totalunits
                              ? formik.values.packagingDetails?.packagingType
                                  ?.totalunits
                              : 0}{" "}
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Weight:{" "}
                            {formik.values.packagingDetails?.packagingType
                              ?.totalweight
                              ? formik.values.packagingDetails?.packagingType
                                  ?.totalweight
                              : 0}{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .weightunit
                            }
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Volume:{" "}
                            {formik.values.packagingDetails?.packagingType
                              ?.totalvolume
                              ? formik.values.packagingDetails?.packagingType
                                  ?.totalvolume
                              : 0}{" "}
                            {formik.values.packagingDetails.shipmentTotal.unit}
                          </span>
                        </div>
                      ) : (
                        <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-1">
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Unit:{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .totalunits
                            }
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Weight:{" "}
                            {
                              formik.values.packagingDetails.shipmentTotal
                                .totalweight
                            }
                          </span>
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            Total Volume:{" "}
                            {
                          Number(formik.values.packagingDetails.shipmentTotal
                                .totalvolume).toFixed(3)
                            }
                          </span>
                        </div>
                      )
                    ) : (
                      <span>Add Packaging Details</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="packagingDetails.packagingType.totalunits" //packingDetails.packagingDetailsBy
                    component={TextError}
                  />
                </div>
                <div className="sm:col-span-12 md:col-span-12 lg:col-span-12 col-span-5">
                  <p className="font-semibold text-xs text-formlabel leading-4 my-2">
                    Payment Terms<span className="text-red-800">*</span>
                  </p>
                  <div
                    onClick={(e) => handleClick(e, formik, "PaymentTerms")}
                    className="relative cursor-pointer bg-white border border-gray-300 text-placeholder text-sm rounded-md font-normal w-full px-5 py-3 flex items-center justify-between gap-3"
                  >
                    {formik.values.paymentTerms.incoTerms ||
                    formik.values.paymentTerms.paymentType ? (
                      <div className="text-white font-normal text-sm leading-4 flex items-center flex-wrap gap-3">
                        <span className="bg-primary px-2.5 py-1 rounded-sm ">
                          {formik.values.paymentTerms.paymentType}
                        </span>
                        {formik.values.paymentTerms.incoTerms && (
                          <span className="bg-primary px-2.5 py-1 rounded-sm ">
                            {formik.values.paymentTerms.incoTerms}
                          </span>
                        )}
                        {formik.values.paymentTerms.optionalVas.length > 0 && (
                          <span>
                            {/* {formik.values.paymentTerms.optionalVas.map(
                              (item, index) => (
                                <span key={index} className="bg-primary px-2.5 py-1 rounded-sm mr-2">
                                  {item}{" "}

                                </span>
                              )
                            )} */}
                            {/* {formik?.values?.paymentTerms?.optionalVas?.map((id, index) => {
                              console.log(vasoptiondata, formik?.values?.paymentTerms,"vasoptiondata");
  const matchedItem = vasoptiondata?.find(v => v?.vatId === id);
  return matchedItem ? (
    <span key={index} className="bg-primary px-2.5 py-1 rounded-sm mr-2">
      {matchedItem.type}-{matchedItem.chargeHeadName}
    </span>
  ) : null;
})} */}

                            {Array.isArray(
                              formik?.values?.paymentTerms?.optionalVas
                            ) && (
                              <div className="flex flex-col">
                                {formik.values.paymentTerms.optionalVas.map(
                                  (item, index) => {
                                    // If item is already an object (has 'type' and 'chargeHead'), render directly
                                    if (typeof item === "object") {
                                      return (
                                        <span
                                          key={index}
                                          className="bg-primary px-2.5 py-1  m-2 rounded-sm mr-2"
                                        >
                                          {item.type.charAt(0).toUpperCase() +
                                            item.type.slice(1)}{" "}
                                          - {item.chargeHeadName}
                                        </span>
                                      );
                                    }

                                    // Else item is ID, find matching item in vasoptiondata
                                    const matchedItem = vasoptiondata?.find(
                                      (v) => v?.vatId === item
                                    );
                                    return matchedItem ? (
                                      <span
                                        key={index}
                                        className="bg-primary px-2.5 py-1 m-2 rounded-sm mr-2"
                                      >
                                        {matchedItem.type
                                          .charAt(0)
                                          .toUpperCase() +
                                          matchedItem.type.slice(1)}
                                        -{matchedItem.chargeHeadName}
                                      </span>
                                    ) : null;
                                  }
                                )}
                              </div>
                            )}
                          </span>
                        )}
                      </div>
                    ) : (
                      <span>Add Payment Terms</span>
                    )}
                    <RightOutlined />
                  </div>
                  <ErrorMessage
                    name="paymentTerms.incoTerms"
                    component={TextError}
                  />
                </div>
                <div className="sm:col-span-12 md:col-span-6 lg:col-span-6 col-span-2 relative flex items-end w-full">
                  {type !== "kam_admin" && (
                    <button
                      type="submit"
                      className="text-white bg-primary hover:bg-secondary font-medium rounded-lg text-sm px-4 py-3 text-center  w-full flex items-center justify-center gap-2 shadow-searchbox"
                    >
                      <SearchOutlined />
                      <span>Search</span>
                    </button>
                  )}
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      {isOpen && popup === "destination" && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-120">
            <div className="flex justify-start pt-2 pl-2 bg-gray-100 text-[#f5aa06] text-2xl rounded-md text-center items-center border-b pb-2">
              {/* <h2 className="text-lg font-semibold"> */}
              Confirm delivery and Vehicle Type
              {/* </h2> */}
            </div>
            <p className="text-gray-500 mt-4">
              Since you have requested door pickup and delivery, please confirm
              <br />
              the vehicle type that suits your requirement.
            </p>
            <div className="space-y-4 flex flex-col justify-between items-center w-fit py-4">
              <div className="space-y-4 flex justify-between items-center py-4">
                <div className="p-2 m-5">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Destination Location{" "}
                    <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={destination}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    disabled={true}
                    defaultValue={destinationDistance}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.destinationVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        destinationVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value="">
                      {destinationvehicle[0]?.name
                        ? destinationvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {destinationvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pr-12">
              <button
                type="button"
                onClick={handlemodalclose}
                className="px-4 py-2 border rounded bg-black text-white hover:bg-yellow-600"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 border rounded bg-yellow-600 text-white hover:bg-black"
                onClick={handleproceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpen && popup === "origin" && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-120">
            <div className="flex justify-start pt-2 pl-2 bg-gray-100 text-[#f5aa06] text-2xl rounded-md text-center items-center border-b pb-2">
              {/* <h2 className="text-lg font-semibold"> */}
              Confirm delivery and Vehicle Type
              {/* </h2> */}
            </div>
            <p className="text-gray-500 mt-4">
              Since you have requested door pickup and delivery, please confirm
              <br />
              the vehicle type that suits your requirement.
            </p>
            <div className="space-y-4 flex flex-col justify-between items-center w-fit py-4">
              <div className="space-y-4 flex justify-between items-center py-4">
                <div className="p-2 m-5">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Origin Location <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={origin}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    defaultValue={originDistance}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.originVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        originVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value={originvehicle[0]?._id}>
                      {originvehicle[0]?.name
                        ? originvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {originvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pr-12">
              <button
                type="button"
                onClick={handlemodalclose}
                className="px-4 py-2 border rounded bg-black text-white hover:bg-yellow-600"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 border rounded bg-yellow-600 text-white hover:bg-black"
                onClick={handleproceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      {isOpen && popup === "both" && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-120">
            <div className="flex justify-start pt-2 pl-2 bg-gray-100 text-[#f5aa06] text-2xl rounded-md text-center items-center border-b pb-2">
              {/* <h2 className="text-lg font-semibold"> */}
              Confirm delivery and Vehicle Type
              {/* </h2> */}
              {/* <button onClick={onClose} className="text-gray-500 hover:text-gray-700">&times;</button> */}
            </div>
            <p className="text-gray-500 mt-4">
              Since you have requested door pickup and delivery, please confirm
              <br />
              the vehicle type that suits your requirement.
            </p>
            <div className="space-y-4 flex flex-col justify-between items-center w-fit py-4">
              <div className="space-y-4 flex justify-between items-center ">
                <div className="p-2 m-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Destination Location{" "}
                    <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={destination}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    disabled={true}
                    defaultValue={destinationDistance}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.destinationVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        destinationVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value={destinationvehicle[0]?._id}>
                      {destinationvehicle[0]?.name
                        ? destinationvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {destinationvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="space-y-4 flex justify-between items-center ">
                <div className="p-2 m-2 ">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    origin Location <span className="block">(_ of Goods)</span>
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact person name"
                    defaultValue={origin}
                    disabled={true}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Distance
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    // placeholder="Enter contact number"
                    disabled={true}
                    defaultValue={originDistance}
                  />
                </div>
                <div className="p-2 m-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Vehicle Type
                  </label>

                  <select
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    value={selectedVehicle?.originVehicle}
                    onChange={(e) =>
                      setSelectedVehicle((prev) => ({
                        ...prev,
                        originVehicle: e.target.value,
                      }))
                    }
                  >
                    <option value={originvehicle[0]?._id}>
                      {originvehicle[0]?.name
                        ? originvehicle[0]?.name
                        : "Vehicle Type"}
                    </option>
                    {originvehicle?.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end space-x-2 pr-12">
              <button
                type="button"
                onClick={handlemodalclose}
                className="px-4 py-2 border rounded bg-black text-white hover:bg-yellow-600"
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 border rounded bg-yellow-600 text-white hover:bg-black"
                onClick={handleproceed}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      <Popover
        className="w-full overflow-y-scroll"
        PaperProps={{
          // style: {
          //   width:
          //     popForm === "PackagingDetails" && webopen === true
          //       ? "75%"
          //       : webopen === false
          //       ? "100%"
          //       : popForm==="OriginAirport" || popForm==="DestinationAirport" ? "35%" : "50%",
          //   boxShadow: "10px 10px 10px 10px gray",
          //   borderRadius: "16px",

          // },
          style: {
            width:
              popForm === "PackagingDetails"||popForm==="GoodDetails" && webopen === true
                ?"75%"
                :"auto", // Fit width to content
            height:popForm==="GoodDetails" && webopen === true
                ?"68%"
                :"auto", // Fit height to content
            maxWidth: "none", // Allow full dynamic width
            boxShadow: "10px 10px 10px 10px gray",
            borderRadius: "16px",
            marginTop: "5px",
            marginBottom: "5px",
            overflowY: "auto",
          },
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        // anchorOrigin={{ vertical: "top", horizontal: "left" }}
        // transformOrigin={{ vertical: "top", horizontal: "left" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        {popForm === "OriginAirport" ? (
          <Suspense fallback={<Skeleton active />}>
            <OriginAirport
              formikData={formikData}
              setAnchorEl={setAnchorEl}
              airports={airports}
              allairports={allAirportsState?.allairports}
            />
          </Suspense>
        ) : popForm === "DestinationAirport" ? (
          <Suspense fallback={<Skeleton active />}>
            <DestinationAirport
              formikData={formikData}
              setAnchorEl={setAnchorEl}
              airports={airports}
              allairports={allAirportsState?.allairports}
            />
          </Suspense>
        ) : popForm === "GoodDetails" ? (
          <Suspense fallback={<Skeleton active />}>
            {/**/}
            {Greeting({formikData,Formik})}
            {/* <div>hi</div> */}
          </Suspense>
        ) : popForm === "PackagingDetails" ? (
          <Suspense fallback={<Skeleton active />}>
            <PackagingDetails
              formikData={formikData}
              setAnchorEl={setAnchorEl}
            />
          </Suspense>
        ) : (
          popForm === "PaymentTerms" && (
            <Suspense fallback={<Skeleton active />}>
              <PaymentTerms
                formikData={formikData}
                setVasOptionData={setVasOptionData}
                setAnchorEl={setAnchorEl}
                allairports={allAirportsState?.allairports}
                // originAirport={formik.values.originAirport}
                // destinationAirport={formik.values.destinationAirport}
              />
            </Suspense>
          )
        )}
      </Popover>
      <ToastContainer position="top-center" autoClose={6000} />
    </>
  );
};

export default NewFlightRate;
